import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { Async } from 'react-select';
import validator from "validator";
import GlobalHelper from "../common/GlobalHelper.jsx";
import Icon from "../common/icon/icon.component.jsx";
import { CONTACT_TYPE } from "../utils/contacts";

const messages = defineMessages({
    "search_create_company_placeholder": {
        id: 'customers.placeholder.search_create_company_dropdown',
        defaultMessage: 'Select or type in company name...',
    },
    "search_create_supplier_placeholder": {
        id: 'customers.placeholder.search_create_supplier_dropdown',
        defaultMessage: 'Select or type in supplier name...',
    },
    "search_or_create_prompt_text": {
        id: 'customers.placeholder.search_or_create_prompt_text',
        defaultMessage: 'Search or create a company...',
    },
    "search_or_create_prompt_text_supplier": {
        id: 'customers.placeholder.search_or_create_prompt_text_supplier',
        defaultMessage: 'Search or create a supplier...',
    },
    "create_company_prompt_message": {
        id: 'customers.create_company_dropdown_prompt',
        defaultMessage: 'Create company',
    },
    "select_customer_placeholder": {
        id: 'customers.placeholder.select_customer_dropdown',
        defaultMessage: 'Select a customer...',
    },
    "search_contact_prompt_text": {
        id: 'customers.placeholder.search_prompt_text.contact',
        defaultMessage: 'Search among contacts...',
    },
    "search_supplier_prompt_text": {
        id: 'customers.placeholder.search_prompt_text.supplier',
        defaultMessage: 'Search among suppliers...',
    }
})

class CustomerSelect extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            options: [],
            multi: this.props.multi || false,
            onlyLabel: this.props.onlyLabel || false,
            selectedOptions: this.props.defaultSelectedOptions && {id : '', value : ''},
            allowCreate: this.props.allowCreate || false,
            contactType: this.props.contactType || '',
            filters: this.props.filters || {},
            customers: [],
            showAddressInLabel: this.props.showAddressInLabel || false,
            addressType: this.props.addressType || 'billing',
            clearable: !isNaN(this.props.clearable) ? this.props.clearable : true,
            placeholder: this.props.placeholder || messages["select_customer_placeholder"],
        }

        const defaultCallback = () => { }
        this.id = this.props.id
        this.name = this.props.name
        this.contactType = this.props.contactType || ''
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
        this.handleBlur = this.handleBlur.bind(this)
        this.loadCustomers = this.loadCustomers.bind(this)
    }

    componentDidMount() {
        this.loadInitialCustomer(this.props.value)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            allowCreate: nextProps.allowCreate,
            contactType: nextProps.contactType || '',
            addressType: nextProps.addressType || 'billing',
            showAddressInLabel: nextProps.showAddressInLabel || false,
            filters: nextProps.filters || {},
        }, () => {
            if (!Array.isArray(nextProps.value) && nextProps.value && (!this.state.selectedOptions || nextProps.value !== this.state.selectedOptions.value)) {
                if (validator.isUUID(nextProps.value)) {
                    this.loadInitialCustomer(nextProps.value)
                }
            } else if (!nextProps.value) {
                this.setState({
                    selectedOptions: null,
                })
            }
        })
    }

    handleChange(selectedOptions) {
        if (this.state.multi) {
            if (selectedOptions === null) {
                this.props.onChange([], "")
            } else {
                var values = []
                var labels = []

                selectedOptions.forEach(elem => {
                    if (validator.isUUID(elem.value)) {
                        values.push(elem.value)
                        labels.push(elem.label)
                    }
                })
                this.props.onChange(values, labels.join(','))
            }
        } else {
            var val = ''
            var label = ''
            if (selectedOptions) {
                val = selectedOptions.value
                label = selectedOptions.label
            }
            this.onChange(val, label)
        }

        this.setState({
            selectedOptions: selectedOptions
        });
    }

    handleBlur(event) {
        //call onChange only if the input text has more value than the selected dropdown option
        // (i.e. when it's not empty and nothing is selected in the dropdown
        // or when the input is different from the selected option
        if ((!this.state.selectedOptions || !this.state.selectedOptions.value || this.state.selectedOptions.value != event.target.value) && event.target.value) {
            this.onChange(event.target.value)
        }
    }

    loadCustomers(input, callback) {
        let postData = {
            keywords: GlobalHelper.formatSearchKeywords(input),
            objects: ['contacts'],
            fields: [
                'name',
                'nameAnalyzed',
                'nameKeyword',
                'nameSort',
                'phoneNumber',
                'address',
                'citySort',
                'cityKeyword',
                'organizationName',
                'organizationNameAnalyzed',
                'organizationNameKeyword',
            ],
            pageSize: 50,
            activePage: 1,
            sortByField: 'nameSort',
            sortAsc: true,
            lightResult: true,
            filters: this.state.filters,
        }
        if (this.state.contactType) {
            postData.filters.contactType = this.state.contactType
        }
        AppContext.getApiClient().post('/listing/search', postData).then((response) => {
            this.setState({
                customers: response.data,
            })

            const opt = response.data?.map(p => {
                if (this.state.onlyLabel) {
                    return { value: p.id, label: p.name }
                } else {
                    return {
                        value: p.id,
                        label: <div className={'w-100 mb-0'} tagname={p.name}>
                            <p className={'mb-0'}>
                                {p.contactType === 'organizations' ? <Icon value={'building'} className={'mr-1'} /> : null}
                                <strong>{p.name}</strong> {this.state.showAddressInLabel &&
                                    <div>
                                        {this.state.addressType === 'billing' ? p.address : p.shippingAddress}
                                    </div>
                                }
                                {p.isPrimaryContact ? <span className="badge badge-pill badge-info">
                                    <FormattedMessage
                                        id="customers.selection.primary_label"
                                        defaultMessage="Primary"
                                    />
                                </span> : null}
                            </p>
                            {p.organizationName && p.contactType === 'persons' ? <p className={'mb-0'}>
                                <small>
                                    <Icon value={'building'} /> {p.organizationName}
                                </small>
                            </p> : null}
                        </div>
                    }
                }
            })

            callback(null, {
                options: opt,
                complete: false,
            })
        })
    }

    loadInitialCustomer(value) {
        if (this.state.multi) {
            let promises = []
            for (let v of value) {
                promises.push(AppContext.getApiClient().get('/contacts/' + v))
            }
            Promise.all(promises).then(res => {
                this.setState({
                    selectedOptions: res.map(contact => {
                        return {
                            value: contact.id,
                            label: contact.attributes.name,
                        }
                    })
                })
            })
        } else {
            if (value && validator.isUUID(value)) {
                AppContext.getApiClient().get('/contacts/' + value).then(res => {
                    this.setState({
                        selectedOptions: {
                            value: res.id,
                            label: res.attributes.name
                        }
                    })
                })
            }
        }
    }

    render() {

        const message = this.props.contactType === CONTACT_TYPE.SUPPLIER ? messages["search_create_supplier_placeholder"] :
            messages["search_create_company_placeholder"]

        const promptMessage = this.props.contactType === CONTACT_TYPE.SUPPLIER ? messages["search_or_create_prompt_text_supplier"] :
            messages["search_or_create_prompt_text"]

        const searchPromptMessage = this.props.contactType === CONTACT_TYPE.SUPPLIER ? messages["search_supplier_prompt_text"] :
            messages["search_contact_prompt_text"]

        if (this.state.allowCreate) {

            return (
                <Async
                    cache={false}
                    placeholder={this.props.intl.formatMessage(message)}
                    name={this.name}
                    value={this.state.selectedOptions}
                    onChange={this.handleChange}
                    loadOptions={this.loadCustomers}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    onBlur={this.handleBlur}
                    searchPromptText={this.props.intl.formatMessage(promptMessage)}
                    tabSelectsValue={false}
                    id={this.id}
                    filterOptions={false}
                />
            )
        } else {
            return (
                <Async
                    disabled={this.props.disabled ?? false}
                    className={this.props.className ?? ""}
                    cache={false}
                    menuPortalTarget={document.body}
                    filterOptions={this.state.multi ? true : false}
                    multi={this.state.multi}
                    placeholder={this.props.intl.formatMessage(this.state.placeholder)}
                    name={this.name}
                    id={this.id}
                    value={this.state.selectedOptions}
                    onChange={this.handleChange}
                    loadOptions={this.loadCustomers}
                    searchPromptText={this.props.intl.formatMessage(searchPromptMessage)}
                    clearable={this.state.clearable}
                />
            )
        }

    }
}

export default injectIntl(CustomerSelect)





// WEBPACK FOOTER //
// ./src/customer/selection.component.jsx